"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "donato": {
    "802251a9": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "skipSearch": false
    }],
    "ban": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2a59d073": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "skipSearch": false
    }],
    "casale": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "621ce4f1": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "skipSearch": false
    }],
    "cugnello": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5b349628": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "skipSearch": false
    }],
    "faipian": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "789d537a": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "skipSearch": false
    }],
    "grangia": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c7f64f69": [{
      "hkey": "43d12d83",
      "slug": "ceresito",
      "name": "Ceresito",
      "primary": true,
      "skipSearch": false
    }],
    "localita-ceresito": [{
      "hkey": "43d12d83",
      "slug": "ceresito",
      "name": "Ceresito",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "98c54042": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "skipSearch": false
    }],
    "losana": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9eb5f8f4": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "skipSearch": false
    }],
    "molino": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3ff5c9b9": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "skipSearch": false
    }],
    "montino": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "94d21442": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "skipSearch": false
    }],
    "piazzo": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "51efb24b": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "skipSearch": false
    }],
    "poneira": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1675764d": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "skipSearch": false
    }],
    "praie": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c52693aa": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "skipSearch": false
    }],
    "pralungo": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "39f6f4c1": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "skipSearch": false
    }],
    "raviale": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "acfb079d": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "skipSearch": false
    }],
    "roncasso": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0f982285": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "skipSearch": false
    }],
    "ruscello": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0bce1825": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "skipSearch": false
    }],
    "sacco": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c5f54b25": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "skipSearch": false
    }],
    "serra": [{
      "hkey": "3c3b0947",
      "slug": "donato",
      "name": "Donato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;